{
  "replaceMessage": "Přetáhněte soubor k nahrazení"
}
